import Events from '../../utilities/EventEmitter';
import appConstants from '../../appConstants';
import { RMAXLogger } from '../../services/LoggerService/RMAXLogger';
import { isTrailerMovePickupEvent } from '../../components/header/dispatchHeader/PickupEventHandler/trailerMovePickupHandler';
import {
  endTripEvents,
  equipmentUpdateEvents,
  voidUnvoidEvents
} from '../EventMappingConfig';
import { APP_EVENT_NAMES, DISPATCH_SUB_EVENTS } from '../constants';

const { DISPATCH } = APP_EVENT_NAMES;

export const dispatchCanceled = (_terminalCode, dataString) => {
  console.log('dispatchCanceled completed');
  const data = JSON.parse(dataString);
  Events.emit(DISPATCH.dispatchCanceled, {
    eventName: DISPATCH_SUB_EVENTS.dispatchCanceled,
    driverId: data.driverId
  });
  Events.emit(DISPATCH.UpdatedClosedTrailers, data);
};

export const pickupAssigned = (_terminalCode, dataString) => {
  const data = JSON.parse(dataString);
  console.log('pickupAssigned completed');
  Events.emit(DISPATCH.HandlePickupEvent, dataString, appConstants.PICKUP_EVENTS.ASSIGN_PICKUP);
  if (isTrailerMovePickupEvent(data)) {
    Events.emit(DISPATCH.HandleTrailerMovesEvent, data, appConstants.PICKUP_EVENTS.ASSIGN_PICKUP);
  }
};

export const pickupUnassigned = (_terminalCode, dataString) => {
  const data = JSON.parse(dataString);
  console.log('pickupUnassigned completed');
  Events.emit(DISPATCH.HandlePickupEvent, dataString, appConstants.PICKUP_EVENTS.UNASSIGN_PICKUP);
  if (isTrailerMovePickupEvent(data)) {
    Events.emit(DISPATCH.HandleTrailerMovesEvent, data, appConstants.PICKUP_EVENTS.UNASSIGN_PICKUP);
  }
  if(data.isEntireGroupUnassigned) Events.emit(DISPATCH.DispatchUngroupPickup, data);
};

export const driverAssigned = (_terminalCode, dataString) => {
  console.log('DriverAssigned completed');
  const data = JSON.parse(dataString);
  Events.emit(DISPATCH.RefreshDispatchStore, {
    driverIds: [data.driverId],
    refreshPickups: data.arePickupsInRoute
  });
};

export const updateFromDriverApp = (_terminalCode, dataString) => {
  console.log('Update from DriverApp');
  const data = JSON.parse(dataString);
  switch (data.eventType) {
    case DISPATCH_SUB_EVENTS.StopsCompleted:
      Events.emit(DISPATCH.DeliveryCompleted, data);
      if (data?.arePickupsMissed) {
        Events.emit(DISPATCH.RefreshPickupsData);
      }
      break;
    case DISPATCH_SUB_EVENTS.NextStopChanged:
      if (data.isDispatcherUpdatedSequence) {
        Events.emit(DISPATCH.NextStopChanged, data);
      }
      break;
    case DISPATCH_SUB_EVENTS.EndOfTrip:
      Events.emit(DISPATCH.EndOfTripCompleted, data);
      Events.emit(DISPATCH.refreshAvailableDrivers, data);
      if (data?.arePickupsMissed) {
        Events.emit(DISPATCH.RefreshPickupsData);
      }
      break;
    case DISPATCH_SUB_EVENTS.DispatchStartTrip:
      Events.emit(DISPATCH.DispatchStartTripCompleted, data);
      break;
    case DISPATCH_SUB_EVENTS.PickupCompleted:
    case DISPATCH_SUB_EVENTS.NoFreightPickedUp:
    case DISPATCH_SUB_EVENTS.AddProToCompletedPickup: {
      Events.emit(DISPATCH.PickupCompleted, data);
      const pickupIds = data.pickupIdList?.length > 0 ? data.pickupIdList : [data.pickupId];
      Events.emit(DISPATCH.RefreshPickupsData, pickupIds);
      break;
    }
  }
  Events.emit(DISPATCH.UpdateDriverRoute, data.driverId);
};

export const proAdded = (_terminalCode, dataString) => {
  console.log('Add Pro Completed');
  const data = JSON.parse(dataString);
  if (data.success) {
    Events.emit(DISPATCH.UpdateDriverRoute, data.driverId);
  }
  Events.emit(DISPATCH.proAdded, data);
};

export const dollyDropHookProcessed = (_terminalCode, dataString) => {
  console.log('Dolly Hooked');
  const data = JSON.parse(dataString);
  if (data.success) {
    Events.emit(DISPATCH.UpdateDriverRoute, data.driverId);
  }
  Events.emit(DISPATCH.refreshDolly);
  Events.emit(DISPATCH.dollyHooked, data);
  Events.emit(DISPATCH.equipmentDropped, data);
};

export const trailerHooked = (_terminalCode, dataString) => {
  console.log('Trailer Hooked');
  const data = JSON.parse(dataString);
  if (data.success) {
    Events.emit(DISPATCH.UpdateDriverRoute, data.driverId);
    Events.emit(DISPATCH.RefreshPickupsData);
    Events.emit(DISPATCH.UpdateSpottedTrailers);
  }
  Events.emit(DISPATCH.trailerHooked, data);
};

export const trailerDropped = (_terminalCode, dataString) => {
  console.log('Trailer Dropped');
  const data = JSON.parse(dataString);
  if (data.success) {
    Events.emit(DISPATCH.UpdateDriverRoute, data.driverId);
    Events.emit(DISPATCH.RefreshPickupsData);
    Events.emit(DISPATCH.UpdateSpottedTrailers);
  }
  Events.emit(DISPATCH.equipmentDropped, data);
};

export const bobtailProcessed = (_terminalCode, dataString) => {
  console.log('bobtail Processed');
  const data = JSON.parse(dataString);
  if (data.success) {
    Events.emit(DISPATCH.UpdateDriverRoute, data.driverId);
  }
  Events.emit(DISPATCH.bobtailProcessed, data);
};

export const moveBillsProcessed = (_terminalCode, dataString) => {
  console.log('Move Bills processed');
  const data = JSON.parse(dataString);
  if (data.success) {
    const driverIdList = [data.driverId]; // bills moved from driver
    if (data?.toDriver) {
      driverIdList.push(data.toDriver); //bills moved to driver
    }
    Events.emit(DISPATCH.UpdateDriverRoute, driverIdList);
    Events.emit(DISPATCH.RefreshPickupsData);
  }
  Events.emit(DISPATCH.MoveBills, data);
};

export const dispatchUpdate = (_terminalCode, dataString) => {
  console.log('UpdateStop Completed ');

  const data = JSON.parse(dataString);
  const shouldRefreshEquipment = equipmentUpdateEvents.includes(data.eventType);
  if (shouldRefreshEquipment) {
    Events.emit(DISPATCH.RefreshEquipmentData);
  } else {
    Events.emit(DISPATCH.UpdateDriverRoute, data.driverId);
  }
  if (endTripEvents.includes(data.eventType) && data?.arePickupsMissed) {
    Events.emit(DISPATCH.RefreshPickupsData);
  }
  if (data.eventType === DISPATCH_SUB_EVENTS.EquipmentDefectUpdated) {
    Events.emit(DISPATCH.EquipmentDefectsUpdated, data);
    Events.emit(DISPATCH.AssetUpdateDefects, data);
  }
  if (data.eventType === DISPATCH_SUB_EVENTS.EndOfTrip) {
    Events.emit(DISPATCH.EndOfTripCompleted, data);
    Events.emit(DISPATCH.refreshAvailableDrivers, data);
  }
  if (data.eventType === DISPATCH_SUB_EVENTS.UpdateDriverSchedule) {
    let parsedDriverData = null;
    if (data.driverData) {
      try {
        parsedDriverData = JSON.parse(data.driverData);
      } catch (_err) {
        RMAXLogger.warn('Error parsing driver data', { driverId: data.driverId });
        return;
      }
    }
    Events.emit(DISPATCH.refreshAvailableDrivers, {
      driverId: data.driverId,
      eventMode: data.eventMode,
      driverData: parsedDriverData
    });
  }
  if (appConstants.ASSET_DOLLY_EVENT_LIST.includes(data.eventType)) {
    Events.emit(DISPATCH.AssetDollyUpdate, data);
  }
  if (appConstants.ASSET_TRACTOR_EVENT_LIST.includes(data.eventType)) {
    Events.emit(DISPATCH.AssetTractorUpdate, data);
  }
  if (appConstants.ASSET_TRAILER_EVENT_LIST.includes(data.eventType)) {
    Events.emit(DISPATCH.RefreshTrailersData, data);
  }
};

export const proDeleted = (_terminalCode, dataString) => {
  console.log('Delete Pro Completed');
  const data = JSON.parse(dataString);
  if (!data.isClosedTrailerRoute && data.success) {
    Events.emit(DISPATCH.UpdateDriverRoute, data.driverId);
  }
  Events.emit(DISPATCH.proDeleted, data);
};

export const plannedKPIUpdated = (_terminalCode) => {
  Events.emit(DISPATCH.refreshDispatchKPI);
};

export const pickupUpdated = (_terminalCode, dataString) => {
  //handle createPickup and updatePickup events
  console.log('Pickup Updated completed ');
  const data = JSON.parse(dataString);
  RMAXLogger.info('Received Pickup updated signalR', {
    pickupNumber: data.data?.pickupNumber,
    pickupId: data.pickupId,
    success: data.success,
    eventType: data.eventType
  });
  if (data?.data?.driverId) {
    Events.emit(DISPATCH.UpdateDriverRoute, data.data.driverId, false);
  }
  if (data.eventType === DISPATCH_SUB_EVENTS.ChangePickupTerminal) {
    Events.emit(DISPATCH.showPickupTerminalChangeMessage, data);
  } else if (voidUnvoidEvents.includes(data.eventType)) {
    Events.emit(DISPATCH.VoidAndUnvoidPickup, data);
  } else if (DISPATCH.NoFreightForUnassignedPickup === data.eventType) {
    Events.emit(DISPATCH.NoFreightForUnassignedPickup, data);
  } else if (data.eventType === DISPATCH_SUB_EVENTS.DispatchUngroupPickup) {
    if (data.data.pickupRemovedFromDriver) {
      Events.emit(DISPATCH.UpdateDriverRoute, data.data.pickupRemovedFromDriver, false);
    }
    Events.emit(DISPATCH.DispatchUngroupPickup, data);
  } 

  if (data.eventType === DISPATCH_SUB_EVENTS.ShipperLocationUpdate) {
    Events.emit(DISPATCH.RefreshPickupsData);
  } else if(data?.data?.pickupIds?.length > 0){ // this for only bulk edit and bulk void pickup event.
    Events.emit(DISPATCH.RefreshPickupsData, data.data.pickupIds);
  }
  else {
    Events.emit(DISPATCH.updatePickupListInStore, data);
  }
  if (isTrailerMovePickupEvent(data)) {
    Events.emit(DISPATCH.HandleTrailerMovesEvent, dataString, appConstants.PICKUP_EVENTS.UPDATE_PICKUP);
  }
};

export const duplicatePickupsDetected = () => {
  Events.emit(DISPATCH.RefreshDuplicatePickups);
};


export const messageFromDriver = (_terminalCode, dataString) => {
  console.log('Message From Driver');
  Events.emit(DISPATCH.MessageFromDriver, dataString);
};

export const messageRead = (_terminalCode, dataString) => {
  console.log('Driver Read dispatcher message');
  Events.emit(DISPATCH.DispatcherMessageRead, dataString);
};

export const driverLoginStatusUpdate = (_terminalCode, dataString) => {
  console.log('Driver logged in status updated');
  const data = JSON.parse(dataString);
  Events.emit(DISPATCH.UpdateDriverLoginStatus, data);
};

export const driverDispatched = (_terminalCode, dataString) => {
  console.log('DriverDispatch completed');
  const data = JSON.parse(dataString);
  Events.emit(DISPATCH.RefreshDispatchStore, {
    driverIds: [data.driverId],
    refreshPickups: data.arePickupsInRoute
  });
  Events.emit(DISPATCH.DriverDispatched, data);
  Events.emit(DISPATCH.UpdatedClosedTrailers, data);
};

export const stopMoved = (_eventTerminalCode, dataString) => {
  console.log('Stop Sequence Changed');
  Events.emit(DISPATCH.stopMoved, dataString);
};

export const trailerStatusUpdated = (_terminalCode, dataString) => {
  console.log('Trailer data updated');
  const data = JSON.parse(dataString);
  Events.emit(DISPATCH.RefreshTrailersData, data);
  Events.emit(DISPATCH.RefreshEquipmentData, appConstants.EQUIPMENT_TYPES.Trailer, data);
  Events.emit(DISPATCH.UpdateSpottedTrailers);
  Events.emit(DISPATCH.ClosedTrailerStatusUpdated, data);
};

export const pickupAcknowledged = (_terminalCode, dataString) => {
  console.log('Pickup acknowledged');
  Events.emit(DISPATCH.UpdatePickupAcknowledgedStatus, dataString);
};

export const pickupsMerged = (_terminalCode, dataString) => {
  console.log('Pickups merged');
  const data = JSON.parse(dataString);
  Events.emit(DISPATCH.MergePickups, data);
  Events.emit(DISPATCH.DispatchUngroupPickup, data);
  if (data.success) {
    data.driverId && Events.emit(DISPATCH.UpdateDriverRoute, data.driverId);
    if (data.newPickupId || data.unmergedPickupIds?.length > 0 || data.mergedPickupIds?.length > 0) {
      const pickupIds = [
        ...(data.mergedPickupIds || []),
        ...(data.unmergedPickupIds || []),
        data.newPickupId
      ].filter(Boolean);
      Events.emit(DISPATCH.RefreshPickupsData, pickupIds);
    } else {
      Events.emit(DISPATCH.RefreshPickupsData);
    }
  }
};

export const accessibleTerminalUpdated = (_terminalCode) => {
  console.log('Accessible terminal updated');
  Events.emit(DISPATCH.RefreshAccessibleTerminals);
};

export const kpiUpdated = (_terminalCode, dataString) => {
  console.log('KPIUpdated');
  const data = JSON.parse(dataString);
  Events.emit(DISPATCH.updateKPIData, data);
};

export const pickupRecommendationsAvailable = (_terminalCode, dataString) => {
  const data = JSON.parse(dataString);
  const pickupIds = data?.pickupIds ?? (data?.pickupId ? [data.pickupId] : []);
  RMAXLogger.info('Event RefreshPickupRecommendations received on signalR', {
    pickupIds,
    pickupCount: pickupIds.length
  });
  Events.emit(DISPATCH.RefreshPickupRecommendations, data);
};

export const geofenceArrivalDeparture = (_terminalCode, dataString) => {
  const data = JSON.parse(dataString);
  if (!data.success) {
    return;
  }
  if ([DISPATCH_SUB_EVENTS.EnterTerminal, DISPATCH_SUB_EVENTS.LeaveTerminal].includes(data.eventType)) {
    Events.emit(DISPATCH.updateDriverGateinGateout, data);
  } else {
    Events.emit(DISPATCH.GeofenceArrivalDeparture, data);
  }
}

export const shipperUpdatedFromIBPlanning = (_terminalCode, dataString) => {
  console.log('shipperUpdatedFromIBPlanning');
  const data = JSON.parse(dataString);
  Events.emit(DISPATCH.RefreshPickupsData, data.pickupIds, false);
};

export const revisitDeliveryStop = (_terminalCode, dataString) => {
  console.log('Revisit Delivery Stop');
  const data = JSON.parse(dataString);
  Events.emit(DISPATCH.UpdateDriverRoute, data.driverId);
  Events.emit(DISPATCH.ClosedRevisitStop, data);
};

export const trailerClosed = (_terminalCode, dataString) => {
  console.log('Trailer Closed');
  const data = JSON.parse(dataString);
  Events.emit(DISPATCH.ClosedTrailersUpdated, data);
};

export const trailerMovesUpdated = (_terminalCode, dataString) => {
  const data = JSON.parse(dataString);
  Events.emit(DISPATCH.TrailerMovesUpdated, data);
};
